import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'upper-filter',
    standalone: false
})
export class ScUpperWithFilterPipe implements PipeTransform {
    transform(value: string, filter: string): string {
        return value !== filter ? value.toUpperCase() : '';
    }
}
